import React, { useState, useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext } from 'react-router-dom';
//api
import { createInvoice } from 'api/invoice';
//components
import Title from 'components/backoffice/texts/title';
import InvoiceForm from 'components/backoffice/forms/invoiceForm';

const CreateInvoice = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);
  const {setTitle} = useOutletContext()

  const invoice = {
    order: null,
    name: '',
    status: false,
    billing_address: null
  };

  useEffect(()=>{
    setTitle(t('createinvoice'))
    return () => {
      setTitle('');
    };
  },[setTitle])
  
  const onSubmit = useCallback(
    async (values) => {
      setLoading(true)
      try {
        const order = values.order;
        const payload = {
          order: order.id,
          name: values.name,
          status: values.status,
          billing_address: values.billing_address ? values.billing_address : order.billing_address,
          sub_total: order.subtotal_order,
          vat_total: order.iva_order,
          discount: order.descuento,
          total: order.total_order,
          user: order.user ? order.user.id : null,
          promo_code: order.applied_coupon
        };
        const { status } = await createInvoice(payload);
        if (status === 201) {
          toast.success(t('creadocorrectamente'));
          navigate('/intranet/invoices', { replace: true });
        } else {
          toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
        }
      } catch (error) {
        console.error('Error en onCreate:', error);
      }
      setLoading(false)
    }, []);

  return (
    <div>
      <Title text={t('createinvoice')} />
      <InvoiceForm loading={loading} onSubmitForm={onSubmit} defaultValues={invoice} isEditing={false} />
    </div>
  );
};

export default CreateInvoice;
